<template>
  <modal-inner aria-label="Share document">
    <div class="modal__content">
      <div class="modal__title">Share document</div>
      <p>Anyone with this link can open and import the current document.</p>
      <div v-if="loading" class="share-modal__status">
        Generating link…
      </div>
      <div v-else-if="error" class="share-modal__status share-modal__status--error">
        {{ error }}
      </div>
      <div v-else class="share-modal__link-row">
        <div class="form-entry">
          <div class="form-entry__field">
            <input
              ref="linkInput"
              class="textfield share-modal__input"
              type="text"
              :value="shareUrl"
              readonly
              @focus="$event.target.select()"
            >
            <div class="form-entry__actions">
              <button class="form-entry__button button" @click="copyLink" v-title="'Copy link'">
                <icon-content-copy></icon-content-copy>
              </button>
            </div>
          </div>
        </div>
        <div v-if="copied" class="share-modal__copied">Copied!</div>
      </div>
    </div>
    <div class="modal__button-bar">
      <button class="button button--resolve" @click="config.resolve()">Close</button>
    </div>
  </modal-inner>
</template>

<script>
import { mapGetters } from 'vuex';
import ModalInner from './common/ModalInner';
import shareSvc from '../../services/shareSvc';
import store from '../../store';

export default {
  components: {
    ModalInner,
  },
  data: () => ({
    loading: true,
    error: null,
    shareUrl: '',
    copied: false,
  }),
  computed: {
    ...mapGetters('modal', ['config']),
  },
  async created() {
    try {
      const { text: content } = store.getters['content/current'];
      const { name } = store.getters['file/current'];
      this.shareUrl = await shareSvc.createShare(content, name);
    } catch (e) {
      this.error = 'Could not generate link. Please try again.';
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async copyLink() {
      try {
        await navigator.clipboard.writeText(this.shareUrl);
      } catch (e) {
        // Fallback for browsers without clipboard API
        this.$refs.linkInput.select();
        document.execCommand('copy');
      }
      this.copied = true;
      setTimeout(() => { this.copied = false; }, 2000);
    },
  },
};
</script>

<style lang="scss">
.share-modal__status {
  margin: 1em 0;
  color: #808080;

  &--error {
    color: #de2c00;
  }
}

.share-modal__link-row {
  position: relative;
}

.share-modal__input {
  width: 100%;
  padding: 0.5em 44px 0.5em 0.75em;
  border: none;
  font-size: 0.85em;
  background: transparent;
  cursor: text;
}

.share-modal__copied {
  font-size: 0.8em;
  color: #5a9e3a;
  text-align: right;
  margin-top: 0.25em;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/ShareModal.vue